import { robinBio, sluttyPumpkinBio, stellaBio, tracyBio, victoriaBio, zoeyBio } from './tedBios'
// import { stellaProfileReviewHinge, robinProfileReviewHinge, zoeyProfileReviewBumble } from './tedProfileReviews'
import { stellaReviewerReviewTinder, robinReviewerReviewHinge, zoeyReviewerReviewBumble } from './tedReviewerReviews'

export const robinReviewerProfile = {
  _id: 'robinReviewerProfileId',
  userId: 'robinUserId',
  email: 'robin@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-1.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...robinBio },
  profileReviews: [
    // { ...robinProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...robinReviewerReviewHinge }
  ],
}

export const sluttyPumpkinReviewerProfile = {
  _id: 'sluttyPumpkinReviewerProfileId',
  userId: 'sluttyPumpkinUserId',
  email: 'sluttypumpkin@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-slutty-pumpkin-1.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...sluttyPumpkinBio },
  profileReviews: [
    
  ],
  reviewerReviews: [
    
  ],
}

export const stellaReviewerProfile = {
  _id: 'stellaReviewerProfileId',
  userId: 'stellaUserId',
  email: 'stella@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-stella-1.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...stellaBio },
  profileReviews: [
    // { ...stellaProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...stellaReviewerReviewTinder }
  ],
}

export const tracyReviewerProfile = {
  _id: 'tracyReviewerProfileId',
  userId: 'tracyUserId',
  email: 'tracy@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-tracy-1.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...tracyBio },
  profileReviews: [
    
  ],
  reviewerReviews: [
    
  ],
}

export const victoriaReviewerProfile = {
  _id: 'victoriaReviewerProfileId',
  userId: 'victoriaUserId',
  email: 'victoria@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-victoria-1.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...victoriaBio },
  profileReviews: [
    
  ],
  reviewerReviews: [

  ],
}

export const zoeyReviewerProfile = {
  _id: 'zoeyReviewerProfileId',
  userId: 'zoeyUserId',
  email: 'zoey@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-zoey-1.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...zoeyBio },
  profileReviews: [
    // { ...zoeyProfileReviewBumble }
  ],
  reviewerReviews: [
    { ...zoeyReviewerReviewBumble }
  ],
}
